import React from "react";

import TipoActividad from "./tiposActividades/tipoActividad";

const TiposActividades = ({ data, onOptionClick }) => (
  <div className="columns is-multiline is-centered">
    {data.map(item => (
      <TipoActividad key={item.key} onClick={onOptionClick} data={item} />
    ))}
  </div>
);

export default TiposActividades;
